import { ModalInfo } from '@/components/common';
import { OperatorComputerIcon } from '@/resources/Icons';
import React from 'react';
import styles from './modalSessionExpired.module.scss';

const ModalSessionExpired = () => {
	const content: React.ReactNode = (
		<div className={styles.container}>
			<OperatorComputerIcon className={styles.icon} />
			<span>{`${_('YourSessionHasExpired')}.`}</span>
			<span>{`${_('PleaseLogin')}.`}</span>
		</div>
	);

	return ModalInfo({
		content,
		hideFooter: true,
		hideIcon: true,
		width: '350px',
	});
};

export { ModalSessionExpired };
